import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6 7a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-5a5 5 0 1 0 0 10A5 5 0 0 0 9 2M5 14a5 5 0 0 0-5 5v2a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-2a5 5 0 0 0-5-5zm-2.121 2.879A3 3 0 0 1 5 16h8a3 3 0 0 1 3 3v1H2v-1a3 3 0 0 1 .879-2.121m16.153-1.999a1 1 0 0 1 1.218-.718A5 5 0 0 1 24 18.999V21a1 1 0 1 1-2 0v-2a3 3 0 0 0-2.25-2.902 1 1 0 0 1-.718-1.218M16.248 2.161a1 1 0 1 0-.496 1.938 3 3 0 0 1 0 5.812 1 1 0 1 0 .496 1.938 5 5 0 0 0 0-9.688",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }